import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import Layout from '@/layouts/Layout';
import Login from '@pages/Login';
import BusinessCards from '@pages/BusinessCards';
import Profile from '@pages/Profile';
import { useAuth } from '@contexts/AuthContext';
import { AuthProvider } from '@contexts/AuthContext';

// 路由守卫组件
const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // 如果正在加载，显示加载状态
  if (loading) {
    return (
      <div style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <Spin size="large" />
      </div>
    );
  }

  // 如果未登录，重定向到根路由
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 如果已登录，显示受保护的内容
  return children;
};

const App = () => {
  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: '#008d6a',
          colorLink: '#008d6a',
          colorLinkHover: '#00b386',
          colorLinkActive: '#006d52',
          borderRadius: 6,
        },
      }}
    >
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* 登录路由 */}
            <Route path="/login" element={<Login />} />

            {/* 根路由 - 未登录时重定向到登录页 */}
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="/business-cards" replace />} />
              <Route path="business-cards" element={<BusinessCards />} />
              <Route path="profile" element={<Profile />} />
            </Route>

            {/* 捕获所有未匹配的路由 */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>
  );
};

export default App; 